import { CreateTestsheetQuizPayload, ecsApi, GetTestsheetsQuizResponse, GetTestsheetsResponse, TestsheetListingResponse } from '@services';

export const testsheetsApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getTestsheetsListing: builder.mutation<TestsheetListingResponse, void>({
            query: () => ({
                url: '/testsheets/listing',
                method: 'GET'
            })
        }),
        getTestsheets: builder.mutation<GetTestsheetsResponse, void>({
            query: () => ({
                url: `/testsheets`,
                method: 'GET'
            })
        }),
        getTestsheetQuiz: builder.mutation<GetTestsheetsQuizResponse, string>({
            query: (id) => ({
                url: `/testsheets/quiz?test_sheet_id=${id}`,
                method: 'GET'
            })
        }),
        createTestsheetQuiz: builder.mutation<void, CreateTestsheetQuizPayload>({
            query: (body) => ({
                url: `/testsheets/quiz`,
                method: 'POST',
                body
            })
        })
    })
});

export const { useGetTestsheetsMutation, useGetTestsheetsListingMutation, useGetTestsheetQuizMutation, useCreateTestsheetQuizMutation } =
    testsheetsApi;
